import { render, staticRenderFns } from "./SendABox.vue?vue&type=template&id=cb86efc4&scoped=true&"
import script from "./SendABox.vue?vue&type=script&lang=js&"
export * from "./SendABox.vue?vue&type=script&lang=js&"
import style0 from "./SendABox.vue?vue&type=style&index=0&id=cb86efc4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb86efc4",
  null
  
)

export default component.exports